import '../globalLibrariesMinimal';

import ReactComponentMounter from '../utils/react-component-mounter';

import Microfrontend from '../apps/Microfrontend';

ReactComponentMounter.register({
  Microfrontend
});
